import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelGuideEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelGuideEntity
